/**
 * Languages the admin portal ships.
 *
 * Single source of truth so the switcher, i18next and the RTL handling in App.tsx
 * cannot drift -- adding a language previously meant editing three places and
 * forgetting one of them left a locale that loaded but could not be selected.
 */

export type LanguageOption = {
  /** i18next language code, and the value stored under localStorage.appLanguage. */
  value: string;
  /** Endonym -- shown in the switcher in its own language, not translated. */
  label: string;
};

export const LANGUAGES: LanguageOption[] = [
  { value: "en", label: "English" },
  { value: "fr", label: "Français" },
  { value: "ar", label: "العربية" },
];

/**
 * Base subtags written right-to-left. Compared against the base subtag only, so
 * regional variants such as "ar-DZ" are matched too.
 */
export const RTL_LANGUAGES: string[] = ["ar"];

export const DEFAULT_LANGUAGE = "en";

export const isRtlLanguage = (language?: string | null): boolean =>
  RTL_LANGUAGES.includes((language || DEFAULT_LANGUAGE).split("-")[0]);
